import RootLayout from "@/components/layout/RootLayout";
import { createRootRoute } from "@tanstack/react-router";

export const Route = createRootRoute({
	component: RootLayout,
});
